export default __webpack_public_path__ + "static/media/flexible.8d51241a.svg";